/* Rquiere de mixin.js */

var legalDocument = {
    data() {
        return {
            dateFromLegalDocuments: '2020-07-15',
            dateToLegalDocuments: '2020-07-18',
            listLegalDocuments: [],
            methodsLegalDocument: {
                create: 'legalDocument/register',
                get: 'legalDocuments',
                show: 'legalDocument/',
                generate: '/facturacionCL'
            },
            paginationLegalDocuments: [],
            searchLegalDocuments: '',
            objectLegalDocument: {
                exists: 0,
                id: 0,
                type_legal_document_id: 0,
                legal_document_number: 0,
                date_legal_document: this.currentDate(),
                issuing_entity_id: 0,
                issuing_entity_name: 'Corp Iglesia de los Adventitas del Septimo Dia',
                issuing_entity_document_number: '82745300-5',
                issuing_entity_economic_activity: 'Actividad Religiosa',
                issuing_entity_address_id: 0,
                issuing_entity_address_street: 'Santa Elena 1038',
                issuing_entity_address_comuna: 'Santiago',
                issuing_entity_address_city: 'Santiago',
                receiving_entity_id: 0,
                receiving_entity_name: '',
                receiving_entity_document_number: '',
                receiving_entity_economic_activity: '',
                receiving_entity_address_id: 0,
                receiving_entity_address_street: '',
                receiving_entity_address_comuna: '',
                receiving_entity_address_city: '',
                contact: '',
                phone: '',
                legal_document_details: [],
                observation: '',
                exempt: 0,
                discount: 0,
                surcharge: 0,
                net: 0,
                tax: 0,
                total: 0,
                url: '',
                url_assignable: '',
                legal_document_references: [{
                    type_legal_document_id: 0,
                    legal_document_number: 0,
                    date_legal_document: '',
                    code_reference: 0,
                    reason: ''
                }],
            },
            readonlyReceivingEntityName: false,
            qRowsLegalDocument: 25,
            generatingLegalDocument: false,
            sendingMailLegalDocument: false
        }
    },
    computed: {
    },
    filters: {
    },
    methods: {
        addListLegalDocuments(newLegalDocument) {
            this.listLegalDocuments.unshift(newLegalDocument)
            if (this.listLegalDocuments.length > this.qRowsLegalDocument) {
                this.listLegalDocuments.splice(this.qRowsLegalDocument, 1)
            }
        },
        changeQRowsLegalDocument() {
            localStorage.setItem('qRowsLegalDocument', this.qRowsLegalDocument)
            this.getAllLegalDocuments()
        },
        getAllLegalDocuments(page = 1) {
            let parameters = '?search=' + this.searchLegalDocuments + '&page=' + page + '&qRow=' + this.qRowsLegalDocument + '&fromDate=' + this.dateFromLegalDocuments + '&toDate=' + this.dateToLegalDocuments
            this.$emit('showLockScreen', 'Obteniendo lista de Documentos Legales . . .')
            this.axiosActionIS(this.getApiBackend + this.methodsLegalDocument.get + parameters, 'GET', 'getAllLegalDocumentsResult')
        },
        getAllLegalDocumentsResult(response) {
            if (response.data.success) {
                this.listLegalDocuments = response.data.data
                this.paginationLegalDocuments = response.data.paginate
            } else {
                this.$snotify.error('Problema al tratar de rescatar los documentos legales', 'Error')
            }
            this.getAllLegalDocumentsResultLocal(response)
        },
        getAllLegalDocumentsResultLocal(response) {
            console.log('getAllLegalDocumentsResult no desarrollado', response)
        },
        getByReceivingEntityDocumentNumber(entityDocumentNumber) {
            let url = this.getApiBackend + this.methodsLegalDocument.show + 'entityDocumentNumber/' + entityDocumentNumber
            this.axiosActionIS(url, 'GET', 'getByReceivingEntityDocumentNumberResult')
        },
        getByReceivingEntityDocumentNumberResult(response) {
            this.getByReceivingEntityDocumentNumberResultLocal(response)
        },
        getByReceivingEntityDocumentNumberResultLocal(response) {
            console.log('getByReceivingEntityDocumentNumberResult no desarrollado', response)
        },
        generateLegalDocumentDefault(orderId, param = '') {
            this.generatingLegalDocument = true
            let url = this.getApiBackend + 'order/' + orderId + '/generateLegalDocumentForSubscription?' + param;
            this.axiosActionIS(url, 'GET', 'generateLegalDocumentDefaultResult')
        },
        generateLegalDocumentDefaultResult(response) {
            this.generatingLegalDocument = false
            if (response.data.success == true) {
                this.listLegalDocuments = response.data.data
            }
            this.generateLegalDocumentDefaultResultLocal(response)
        },
        generateLegalDocumentDefaultResultLocal(response) {
            console.log('generateLegalDocumentDefaultResult no desarrollado', response)
        },
        clearObjectLegalDocument() {
            this.objectLegalDocument.exists = 0
            this.objectLegalDocument.id = 0
            this.objectLegalDocument.type_legal_document_id = 0
            this.objectLegalDocument.legal_document_number = 0
            this.objectLegalDocument.date_legal_document = this.currentDate()
            this.objectLegalDocument.issuing_entity_id = 0
            this.objectLegalDocument.issuing_entity_name = 'Corp Iglesia de los Adventitas del Septimo Dia',
                this.objectLegalDocument.issuing_entity_document_number = '82745300-5',
                this.objectLegalDocument.issuing_entity_economic_activity = 'Actividad Religiosa',
                this.objectLegalDocument.issuing_entity_address_id = 0,
                this.objectLegalDocument.issuing_entity_address_street = 'Santa Elena 1038',
                this.objectLegalDocument.issuing_entity_address_comuna = 'Santiago',
                this.objectLegalDocument.receiving_entity_id = 0,
                this.objectLegalDocument.receiving_entity_name = '',
                this.objectLegalDocument.receiving_entity_document_number = '',
                this.objectLegalDocument.receiving_entity_economic_activity = '',
                this.objectLegalDocument.receiving_entity_address_id = 0,
                this.objectLegalDocument.receiving_entity_address_street = '',
                this.objectLegalDocument.receiving_entity_address_comuna = '',
                this.objectLegalDocument.contact = ''
            this.objectLegalDocument.phone = ''
            this.objectLegalDocument.legal_document_details = []
            this.objectLegalDocument.observation = ''
            this.objectLegalDocument.exempt = 0
            this.objectLegalDocument.discount = 0
            this.objectLegalDocument.surcharge = 0
            this.objectLegalDocument.net = 0
            this.objectLegalDocument.tax = 0
            this.objectLegalDocument.total = 0
            this.objectLegalDocument.url = ''
            this.objectLegalDocument.url_assignable = ''
            this.objectLegalDocument.legal_document_references[0].type_legal_document_id = 0
            this.objectLegalDocument.legal_document_references[0].legal_document_number = 0
            this.objectLegalDocument.legal_document_references[0].date_legal_document = ''
            this.objectLegalDocument.legal_document_references[0].code_reference = 0
            this.objectLegalDocument.legal_document_references[0].reason = ''
            this.readonlyReceivingEntityName = false
        },
        migrateLegalDocumentToGenesys(id) {
            let url = this.getApiBackend + this.methodsLegalDocument.show + id + '/migrateGenesys'
            console.log(url)
            this.axiosActionIS(url, 'POST', 'migrateLegalDocumentToGenesysResult')
        },
        migrateLegalDocumentToGenesysResult(response) {
            if (response.data.success == true) {
                this.$snotify.info('Se migró con exito a Genesys el documento Nº ' + response.data.data.nrocomp, 'Migración Exitosa!!!')
            }
            this.migrateLegalDocumentToGenesysResultLocal(response)
        },
        migrateLegalDocumentToGenesysResultLocal(response) {
            console.log('migrateLegalDocumentToGenesysResultLocal no desarrollado', response)
        },
        saveLegalDocument() {
            let method = (this.objectLegalDocument.exists == 0) ? 'POST' : 'PUT'
            this.$emit('showLockScreen', 'Guardando datos . . .')
            console.log(this.getApiBackend + this.methodsLegalDocument.create, this.objectLegalDocument)
            if (method == 'POST') {
                this.axiosActionIS(this.getApiBackend + this.methodsLegalDocument.create, method, 'saveLegalDocumentResult', this.objectLegalDocument)
            } else {
                this.axiosActionIS(this.getApiBackend + this.methodsLegalDocument.show + this.objectLegalDocument.id, method, 'saveLegalDocumentResult', this.objectLegalDocument)
            }
        },
        saveLegalDocumentResult(response) {
            if (response.data.success) {
                this.addListLegalDocuments(response.data.data)
                this.socketEmit(['NEW_LEGAL_DOCUMENT'], response.data.data)
                this.saveLegalDocumentResultLocal(response)
            } else {
                this.$snotify.error(response.data.message, 'Error')
            }
        },
        sendMailLegalDocument(orderId, email) {
            this.sendingMailLegalDocument = true
            let data = { email: email }
            let url = this.getApiBackend + 'order/' + orderId + '/legalDocument/sendMail'
            this.axiosActionIS(url, 'POST', 'sendMailLegalDocumentResult', data)
        },
        sendMailLegalDocumentResult(response) {
            this.sendingMailLegalDocument = false
            this.sendMailLegalDocumentResultLocal(response)
        },
        sendMailLegalDocumentResultLocal(response) {
            console.log('sendMailLegalDocumentResultLocal no desarrollado', response)
        },
        sendToRegulatoryEntity(id) {
            this.$emit('showLockScreen', 'Generando Documento Electronico Legal . . .')
            let url = this.getApiBackend + this.methodsLegalDocument.show + id + this.methodsLegalDocument.generate
            this.axiosActionIS(url, 'GET', 'sendToRegulatoryEntityResult')
        },
        sendToRegulatoryEntityResult(response) {
            if (response.data.success) {
                this.$snotify.success('Se ha generado una ' + response.data.data.type_legal_document + ' Nº ' + response.data.data.legal_document_number, 'SII!!!')
                this.updateDataFacturacionCL(response.data.data)
                this.socketEmit(['UPDATE_DATA_FACTURACIONCL'], response.data.data)
                this.sendToRegulatoryEntityResultLocal(response)
            } else {
                console.log(response)
                this.$snotify.warning(response.data.message, 'Error')
            }
        },
        sendToRegulatoryEntityResultLocal(response) {
            console.log('sendToRegulatoryEntityResultLocal no desarrollada', response)
        },
        setObjectLegalDocument(item) {
            for (const property in item) {
                this.objectLegalDocument[property] = item[property]
            }
        },
        setListeningLegalDocument() {
            this.sockets.subscribe('NEW_LEGAL_DOCUMENT', (data) => { this.addListLegalDocuments(data.body) })
            this.sockets.subscribe('UPDATE_DATA_FACTURACIONCL', (data) => { this.updateDataFacturacionCL(data.body) })
        },
        showLocalDocument(url) {
            this.axiosActionIS(url, 'GET', 'showLocalDocumentResult', null)
        },
        showLocalDocumentResult(response) {
            if (response.data.success) {
                this.setObjectLegalDocument(response.data.data)
            }
            this.showLocalDocumentResultLocal(response)
        },
        updateDataFacturacionCL(legalDocument) {
            let index = this.listLegalDocuments.map((el) => parseInt(el.id)).indexOf(parseInt(legalDocument.id))
            if (index > -1) {
                this.listLegalDocuments[index].legal_document_number = legalDocument.legal_document_number
                this.listLegalDocuments[index].url = legalDocument.url
                this.listLegalDocuments[index].url_assignable = legalDocument.url_assignable
            }
        }
    },
};

export default legalDocument;